<template>
  <div class="spacer">{{ title }} {{ duration }}</div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  layover: String,
});

const duration = computed(() => {
  return props.layover ? props.layover : "NA";
});

const title = computed(() => {
  if (!props.layover) {
    return "Transit";
  } else if (props.layover.includes("d")) {
    return "Stay";
  } else {
    return "Layover";
  }
});
</script>
